const VideoRenderer = ({ url }) => (
    <video controls style={{ width: '100%', maxHeight: '80vh' }}>
        <source src={url} type="video/mp4" />
        Your browser does not support the video tag.
    </video>
);

export { VideoRenderer };
